import { justMock, get, post, put, del, response, done } from "./http-agent";

export { justMock, get, post, put, del, response, done };
